import { render, staticRenderFns } from "./BaseDynamicInput.vue?vue&type=template&id=87666c7e&"
import script from "./BaseDynamicInput.vue?vue&type=script&lang=js&"
export * from "./BaseDynamicInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports